import { externalRequest } from "../../helpers/fetching";
import mutations from "../mutations";

export default {
  namespaced: true,
  state: {
    formDocumentsState: [],
    formDocumentsFinalState: [],
    errorFiles: null,
    formSelected: null,
    formSelectedForEdit: null,
    loading: false,
  },
  mutations,
  actions: {
    setFormDocuments({ commit }, value) {
      commit("setState", { key: "formDocumentsState", value });
    },
    setFormFinalDocuments({ commit }, value) {
      commit("setState", { key: "formDocumentsFinalState", value });
    },
    setLoading({ commit }, value) {
      commit("setState", { key: "loading", value: value });
    },
    async handleContinueDocuments({ commit }, params) {

      return new Promise((resolve) => {
        commit("setState", { key: "loading", value: true });
        externalRequest(params)
          .then((response) => {

            // commit("setState", { key: "formDocumentsFinalState", value: response });

            // response = JSON.parse(response || '[]')
            let responseTest;

            if (response && response.length > 0) {

              // Temp - formulas para probar backorder y dispensación
              responseTest = response.map(r => {
                if (r.numero == '6523654') {
                  r.resultado_descripcion = 'fórmula habilitada para dispensación';
                  r.resultado = 2;
                  r.puntos = [2625, 2697]
                }
                if (r.numero == '7654321') {
                  r.resultado_descripcion = 'fórmula con producto(s) en back order';
                  r.resultado = 4;
                  r.back_order = [{ "plu": 1234, "url": "https://virtocommerce.com/assets/images/what-is-backorder-1.jpg" },
                  { "plu": 8765, "url": "https://retos-operaciones-logistica.eae.es/wp-content/uploads/2020/08/backorder.jpg" }]
                }
                return r;
              });

            } else {

              if (params.data.formulas.search('6523654') > -1) {
                responseTest = [
                  {
                    resultado_descripcion: 'fórmula habilitada para dispensación',
                    resultado: 2,
                    puntos: [2625, 2697],
                    numero: 6523654
                  }
                ];
              } else {
                commit("setState", { key: "errorFiles", value: response });
                commit("setState", { key: "loading", value: false });
              }

            }

            // -----

            commit("setState", { key: "formDocumentsFinalState", value: responseTest });
            commit("setState", { key: "loading", value: false });
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setState", { key: "errorFiles", value: error });
            commit("setState", { key: "loading", value: false });
            resolve();
          });
      });

    },
    reset({ commit }) {
      commit("setState", { key: "formDocumentsState", value: [] });
      commit("setState", { key: "formDocumentsFinalState", value: [] });
      commit("setState", { key: "errorFiles", value: null });
      commit("setState", { key: "formSelected", value: null });
      commit("setState", { key: "formSelectedForEdit", value: null });
      commit("setState", { key: "loading", value: false });
    }
  },
};
